import React from "react";
import { Table } from "react-bootstrap";
import { useEntities } from "../../../hooks/useEntities";
import { ArrowCornerIcon } from "../../../icons";
import styles from "./WorkspaceLock.module.scss";
import { EntityLockForm } from "./EntityLockForm";

export const WorkspaceLock: React.FC = () => {
    const entities = useEntities({ onlyBusiness: true });

    return (
        <section>
            <header className="settings__header">
                <h3>Locks</h3>
            </header>

            <p className={styles.lockDescription}>
                Locks allow Workspace Admins and Accountants to prevent account
                changes during specific time periods.
                <br />
                <a
                    href="https://kickfinance.notion.site/Locked-Periods-20164c4ef014806f8732e11f62fca935"
                    target="_blank"
                    className={styles.moreLink}
                >
                    More about locks <ArrowCornerIcon />
                </a>
            </p>

            <main>
                {entities.length === 0 ? (
                    <p>No business entities available for locking.</p>
                ) : (
                    <Table>
                        <thead>
                            <tr>
                                <th className={styles.statusHeader}>Status</th>
                                <th className={styles.entityHeader}>Entity</th>
                                <th className={styles.dateHeader}>
                                    Lock up to
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {entities.map((entity) => (
                                <EntityLockForm
                                    key={entity.id}
                                    entity={entity}
                                />
                            ))}
                        </tbody>
                    </Table>
                )}
            </main>
        </section>
    );
};
